import { useState, useEffect } from "react";
import api from "../config/api";

const useSearch = (query) => {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!query || query.trim().length < 2) {
      setSuggestions([]);
      return;
    }

    const fetchSuggestions = async () => {
      try {
        setLoading(true);
        const encodedQuery = encodeURIComponent(query.trim());
        let lat = 51.4994;
        let lng = 7.0833;
        try {
          const stored = localStorage.getItem('userFullAddress');
          if (stored) {
            const parsed = JSON.parse(stored);
            if (parsed.coordinates) {
              lng = parsed.coordinates[0];
              lat = parsed.coordinates[1];
            }
          }
        } catch(e) {}
        const res = await api.get(`/search/suggestions?q=${encodedQuery}`);
        
        // API returns suggestions as an array
        let results = Array.isArray(res.data) ? res.data : (res.data?.data || []);

        let nearbyRestList = [];
        try {
          const landingRes = await api.get(`/search/landing?lat=${lat}&lng=${lng}`);
          nearbyRestList = landingRes.data?.nearbyRestaurants || [];
        } catch (err) {
          const fallbackRes = await api.get(`/restaurant?lat=${lat}&lng=${lng}&radiusKm=100`);
          nearbyRestList = fallbackRes.data?.restaurants || fallbackRes.data || [];
        }
        const nearbyRestIds = new Set(nearbyRestList.map(r => r._id?.toString() || r.id?.toString()));

        results = results.filter(item => {
          let rId = item.id || item._id;
          if (item.type === 'dish') {
            if (item.restaurant && typeof item.restaurant === 'object') {
              rId = item.restaurant._id || item.restaurant.id;
            } else {
              rId = item.restaurantId || item.restaurant;
            }
          }
          if (rId && typeof rId === 'object') {
            rId = rId._id || rId.id || rId;
          }
          return rId && nearbyRestIds.has(rId.toString());
        });

        setSuggestions(results);
      } catch (err) {
        console.error("Search suggestions error:", err);
        setSuggestions([]);
      } finally {
        setLoading(false);
      }
    };

    // Add a debounce to avoid too many API calls
    const debounceTimer = setTimeout(fetchSuggestions, 300);
    
    return () => clearTimeout(debounceTimer);
  }, [query]);

  return { suggestions, loading };
};

export default useSearch;